import { ReactNode } from 'react';
import { injectIntl } from 'react-intl';
import Icon, { ICON_MAP } from '@mindtickle/icon';
import Tooltip from '@mindtickle/tooltip';

import { StyledHelpTriggerWrapper, StyledDropdown, menuDropdownOverlayStyle } from './style';
import messages from './messages';
import { IntlType } from '~/components/GlobalHeader/Learner/type';

import { getPopupContainerOnBody } from '@mindtickle/utils';

interface HelpDropdownProps {
  options: ReactNode;
  intl: IntlType;
  isVisible: boolean;
  handleVisibilityChange: (state: boolean) => void;
  overlayClassName?: string;
}

const HelpDropdown = ({
  options,
  intl,
  isVisible,
  handleVisibilityChange,
  overlayClassName = 'gh-help-dropdown-container',
}: HelpDropdownProps) => (
  <StyledDropdown
    options={options}
    align={{ offset: [0, 12] }}
    overlayStyle={menuDropdownOverlayStyle}
    overlayClassName={overlayClassName}
    onVisibleChange={handleVisibilityChange}
    visible={isVisible}
  >
    <Tooltip title={intl.formatMessage(messages.HELP)} getPopupContainer={getPopupContainerOnBody}>
      <StyledHelpTriggerWrapper $isDropdownOpen={isVisible} data-testid="icon-help">
        <Icon
          key={isVisible ? 'HELP_SOLID' : 'HELP_LIGHT'}
          className="help-trigger-icon"
          type={isVisible ? ICON_MAP.HELP_FILLED : ICON_MAP.HELP}
        />
      </StyledHelpTriggerWrapper>
    </Tooltip>
  </StyledDropdown>
);

export default injectIntl(HelpDropdown);
